import cxs from 'cxs/component';
import Theme from 'Theme';
import { Button } from 'elements';
export const AddButton = cxs(Button)({
    width: '100%',
    /*position: 'fixed',*/
    /*bottom: Theme.size.bar,*/
    backgroundColor: Theme.color.background,
    borderTop: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
    /*[mediaQueries.desktop]: {*/
    position: 'absolute',
    bottom: 0,
    borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`
    /*}*/
});



//////////////////
// WEBPACK FOOTER
// ./src/Styles.ts
// module id = 550
// module chunks = 0